import { Forms, Genres, Users } from '@/api/spotwrite';
import { InjectionKey } from 'vue';
import {
  createStore,
  Store,
  useStore as baseUseStore,
} from 'vuex';

export const SAVE_SEARCH_KEYWORD_MUTATION = 'SAVE_SEARCH_KEYWORD';
export const SAVE_ME_MUTATION = 'SAVE_ME';
export const SAVE_GENRES_MUTATION = 'SAVE_GENRES';
export const SAVE_FORMS_MUTATION = 'SAVE_FORMS';
export const CHANGE_GOOD_PRODUCTION_MUTATION = 'CHANGE_GOOD_PRODUCTION';
export const CHANGE_FAVORITE_PRODUCTION_MUTATION = 'CHANGE_FAVORITE_PRODUCTION';

export type SpotwriteState = {
  searchKeyword: string;
  /**
   * ログイン中のユーザ情報
   */
  me: Users;
  /**
   * Forms
   */
  forms: Forms[];
  /**
   * Genres
   */
  genres: Genres[];

  /**
   * いいねが追加および削除された作品の情報
   */
  goodProductionInfo: {
    productionId: number;
    userId: number;
    isOn: boolean;
  },
  /**
   * お気に入りに追加および削除された作品の情報
   */
  favoriteProduction: {
    productionId: number;
    userId: number;
    isOn: boolean;
  },
}

export const stateKey: InjectionKey<Store<SpotwriteState>> = Symbol('');

export const spotwriteStore = createStore<SpotwriteState>({
  getters: {
    getGoodProductionInfo(state) {
      return state.goodProductionInfo;
    },
    getFavoriteProduction(state) {
      return state.favoriteProduction;
    },
    getMe(state) {
      return state.me;
    },
    getGenres(state) {
      return state.genres;
    },
    getForms(state) {
      return state.forms;
    },
    getSearchKeyword(state) {
      return state.searchKeyword;
    },
  },
  mutations: {
    [SAVE_SEARCH_KEYWORD_MUTATION](state, payload: {
      searchKeyword: string;
    }) {
      state.searchKeyword = payload.searchKeyword;
    },
    [SAVE_ME_MUTATION](state, payload: {
      me: Users;
    }) {
      state.me = payload.me;
    },
    [SAVE_GENRES_MUTATION](state, payload: {
      genres: Genres[];
    }) {
      state.genres = payload.genres;
    },
    [SAVE_FORMS_MUTATION](state, payload: {
      forms: Forms[];
    }) {
      state.forms = payload.forms;
    },
    [CHANGE_GOOD_PRODUCTION_MUTATION](state, payload: {
      productionId: number;
      userId: number;
      isOn: boolean;
    }) {
      state.goodProductionInfo = {
        productionId: payload.productionId,
        userId: payload.userId,
        isOn: payload.isOn,
      };
    },
    [CHANGE_FAVORITE_PRODUCTION_MUTATION](state, payload: {
      productionId: number;
      userId: number;
      isOn: boolean;
    }) {
      state.favoriteProduction = {
        productionId: payload.productionId,
        userId: payload.userId,
        isOn: payload.isOn,
      };
    },
  },
  actions: {},
  modules: {},
});

export function useStore() {
  return baseUseStore(stateKey);
}

export default '';
